import { render, staticRenderFns } from "./AddPaperTemplate.vue?vue&type=template&id=71de60cf&scoped=true&"
import script from "./AddPaperTemplate.vue?vue&type=script&lang=js&"
export * from "./AddPaperTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddPaperTemplate.vue?vue&type=style&index=0&id=71de60cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de60cf",
  null
  
)

export default component.exports